import React from 'react';
import { bool, string, shape, number, func } from 'prop-types';
import classnames from 'classnames';
import Message from '../message';
import ActionLabel from '../action-label';
import { StyledLabel } from '@vpp-frontend-components/styled-label';
import { componentEnhance } from '@vpp-frontend-components/component-enhance';
import noop from 'lodash/noop';

const namespace = 'ui-pdp-distance-with-buyer-message';
const DistanceWithBuyerMessage = ({
  className = '',
  body,
  closeable = false,
  hierarchy = 'quiet',
  message_type = 'warning',
  bg_color = 'WHITE',
  actions_position = 'bottom',
  primary_action = null,
  runCatchErrorBoundary = noop,
}) => {
  try {
    const getAction = () => {
      const { label, target, track } = primary_action || {};

      const stylesLabel = { ...(label || {}) };
      delete stylesLabel.text;

      const actionProps = {
        linkLabel: { label: stylesLabel, track },
        highlightedText: { text: label.text },
        url: target,
      };

      return <ActionLabel {...actionProps} />;
    };

    return (
      <Message
        className={classnames(namespace, className)}
        type={message_type}
        closeable={closeable}
        hierarchy={hierarchy}
        bgColor={bg_color}
        actionsPosition={actions_position}
        actions={primary_action && getAction()}
      >
        <StyledLabel
          as="p"
          {...body}
          text={componentEnhance.jsx(body.text, body.values)}
          className={`${namespace}__text`}
          withDangerous={!body.values}
        />
      </Message>
    );
  } catch (error) {
    /* istanbul ignore next */
    return runCatchErrorBoundary(error);
  }
};

DistanceWithBuyerMessage.propTypes = {
  className: string,
  body: shape({
    text: string.isRequired,
  }).isRequired,
  message_type: string,
  closeable: bool,
  hierarchy: string,
  primary_action: shape({
    target: string.isRequired,
    timeout: number,
    duration: number,
    label: shape({
      text: string,
      color: string,
    }),
    icon: shape({
      id: string,
      color: string,
    }),
  }),
  runCatchErrorBoundary: func,
};

export default DistanceWithBuyerMessage;
